import useAsyncEffect from 'lib/frontend/hooks/useAsyncEffect';
import { ColumnService } from 'lib/services/directory';
import { fetchMadlibsConfig } from 'routes/madlib/helpers/config';

export default function useFetchMadlibConfig(madlibConfigPath: string | null) {
  const result = useAsyncEffect({
    fetchData: async () => {
      if (!madlibConfigPath) {
        return null;
      }
      return await fetchMadlibsConfig(madlibConfigPath);
    },
    dependencies: [madlibConfigPath],
    initialData: null,
    errorConfig: {
      service: ColumnService.WEB_PLACEMENT,
      message: 'Failed to fetch madlibs configuration.',
      tags: { madlibConfigPath: madlibConfigPath || '' }
    }
  });
  return result;
}
